import React, { FunctionComponent } from "react";

import CheckIcon from "./icons/CheckIcon";

interface ProgressProps {
  currentPage: number;
  totalPages: number;
  scrollRef: React.Ref<HTMLElement>;
}

const Progress: FunctionComponent<ProgressProps> = ({ currentPage, totalPages, scrollRef }) => (
  <section className="progress" ref={scrollRef}>
    <div className="container--slim">
      <div className="steps">
        <div className="steps__progress" style={{ width: `${100 * ((currentPage - 1) / (totalPages - 1))}%` }}></div>
        <div className="steps__line"></div>

        <ul className="steps__list">
          {Array.from(Array(totalPages)).map((_, i) => (
            <li key={i} className={i + 1 === currentPage ? "current" : ""}>
              <span className="steps__number">{i + 1}</span>
              <span className="steps__tick">
                <CheckIcon />
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Progress;
